import React from "react";
import { Shield, Lock, Database, Mail, CheckCircle2 } from "lucide-react";

export default function PrivacyPage() {
  return (
    <main data-testid="page-privacy" className="relative pt-32 md:pt-40 pb-24">
      <div className="absolute inset-0 bg-grid opacity-20 [mask-image:radial-gradient(ellipse_at_top,black_30%,transparent_70%)]" />
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 h-[360px] w-[360px] rounded-full bg-blue-600/15 blur-[120px]" />

      <div className="relative max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center">
          <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-500/20 to-emerald-500/20 ring-1 ring-white/10">
            <Shield size={26} className="text-blue-300" />
          </div>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl font-bold tracking-tight text-white">
            Politique de <span className="text-gradient-blue">confidentialité</span>
          </h1>
          <p className="mt-4 text-slate-400">
            Dernière mise à jour : 10 décembre 2025
          </p>
        </div>

        <article className="mt-16 space-y-10 text-slate-300 leading-relaxed">
          <section className="rounded-2xl border border-white/5 bg-slate-900/50 p-8">
            <div className="flex items-start gap-4">
              <div className="h-10 w-10 rounded-xl bg-blue-500/15 flex items-center justify-center flex-shrink-0">
                <Database size={18} className="text-blue-300" />
              </div>
              <div>
                <h2 className="font-display text-2xl font-semibold text-white">Fonctionnement local</h2>
                <p className="mt-3">
                  BoostPro fonctionne actuellement <strong className="text-white">en local sur l'appareil de l'utilisateur</strong>.
                  Les données sont stockées dans une <strong className="text-white">base SQLite locale</strong>, directement sur votre téléphone.
                  Aucune information n'est transmise à un serveur distant, et aucune collecte de données n'est effectuée par l'application.
                </p>
              </div>
            </div>
          </section>

          <section className="rounded-2xl border border-white/5 bg-slate-900/50 p-8">
            <div className="flex items-start gap-4">
              <div className="h-10 w-10 rounded-xl bg-emerald-500/15 flex items-center justify-center flex-shrink-0">
                <Lock size={18} className="text-emerald-300" />
              </div>
              <div className="flex-1">
                <h2 className="font-display text-2xl font-semibold text-white">Données stockées localement</h2>
                <p className="mt-3">Les données suivantes peuvent être stockées localement, dans la base SQLite de votre appareil :</p>
                <ul className="mt-4 grid sm:grid-cols-2 gap-2">
                  {["clients", "factures", "dépenses", "frais de véhicule", "statistiques"].map((d) => (
                    <li key={d} className="flex items-center gap-2 text-slate-200">
                      <CheckCircle2 size={16} className="text-emerald-400" /> {d}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </section>

          <section className="rounded-2xl border border-white/5 bg-slate-900/50 p-8">
            <h2 className="font-display text-2xl font-semibold text-white">Nos engagements</h2>
            <ul className="mt-5 space-y-3">
              <li className="flex items-start gap-3"><CheckCircle2 size={18} className="text-emerald-400 mt-0.5" /> Aucune collecte de données par l'application.</li>
              <li className="flex items-start gap-3"><CheckCircle2 size={18} className="text-emerald-400 mt-0.5" /> Aucune donnée n'est vendue.</li>
              <li className="flex items-start gap-3"><CheckCircle2 size={18} className="text-emerald-400 mt-0.5" /> Aucune donnée n'est partagée avec des tiers.</li>
              <li className="flex items-start gap-3"><CheckCircle2 size={18} className="text-emerald-400 mt-0.5" /> Aucun tracking publicitaire n'est utilisé.</li>
            </ul>
          </section>

          <section className="rounded-2xl border border-white/5 bg-slate-900/50 p-8">
            <h2 className="font-display text-2xl font-semibold text-white">Vos droits</h2>
            <p className="mt-3">
              Les données étant stockées localement sur votre appareil, vous en gardez le contrôle total.
              Vous pouvez à tout moment supprimer l'application pour effacer l'ensemble des informations qu'elle contient.
              Pour toute question relative à la protection de vos données, vous pouvez nous contacter à l'adresse ci-dessous.
            </p>
          </section>

          <section className="rounded-2xl border border-white/5 bg-gradient-to-br from-blue-600/10 to-emerald-500/10 p-8">
            <div className="flex items-start gap-4">
              <div className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                <Mail size={18} className="text-blue-200" />
              </div>
              <div>
                <h2 className="font-display text-2xl font-semibold text-white">Contact</h2>
                <p className="mt-3">
                  Pour toute question concernant cette politique de confidentialité :
                </p>
                <a
                  data-testid="privacy-email-link"
                  href="mailto:boostpro.app@gmail.com"
                  className="mt-2 inline-block text-blue-300 hover:text-blue-200 font-medium"
                >
                  boostpro.app@gmail.com
                </a>
              </div>
            </div>
          </section>
        </article>
      </div>
    </main>
  );
}
